import React, { useState } from 'react';
import { MailIcon, MessageCircleIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { commodities } from '../data/products';
import { company } from '../data/company';
import { quickOrderMailto, whatsappLink } from '../utils/contact';
export function Commodities() {
  const [active, setActive] = useState(commodities[0].id);
  return <>
      <PageHeader eyebrow="Specifications & minimum lots" title="Commodities we supply and export" intro="Grades, packaging, capacity and payment structures for every line we trade. Select a commodity to see the full specification, then send the desk your quantity and destination." image={commodities[2].image} imageAlt="Stacked LME Grade A copper cathode sheets in an export warehouse" data-id="element-278" data-mp="7w9lvfac4qtu" />

      <section className="mx-auto max-w-shell px-6 py-16" data-id="element-279" data-mp="3l3l1sdr1jutr">
        <div className="flex gap-2 overflow-x-auto border-b border-hair pb-px thin-scroll" role="tablist" aria-label="Commodity specifications" data-id="element-280" data-mp="3q2e73iw6cfiu">
          {commodities.map(commodity => {
          const selected = commodity.id === active;
          return <button key={commodity.id} role="tab" aria-selected={selected} type="button" onClick={() => setActive(commodity.id)} className={`shrink-0 border-b-2 px-4 py-3 text-sm font-medium transition-colors duration-150 ${selected ? 'border-gold text-gold-light' : 'border-transparent text-muted hover:text-bone'}`} data-id="element-281" data-mp="1q18mi9moi2jt">
                {commodity.name}
              </button>;
        })}
        </div>

        {commodities.filter(commodity => commodity.id === active).map(commodity => <div key={commodity.id} className="mt-12 grid gap-12 lg:grid-cols-[1.1fr_1fr]" data-id="element-282" data-mp="ajf7gnymkeyh">
              <div data-id="element-283" data-mp="29o6yn34081wb">
                <img src={commodity.image} alt={commodity.name} className="w-full border border-hair object-cover" data-id="element-284" data-mp="29ootpwexka2n" />
                <div className="mt-6 grid grid-cols-2 gap-6 border border-hair bg-panel p-6 sm:grid-cols-4" data-id="element-285" data-mp="2jfa0w88o6mx6">
                  {[{
              label: 'Minimum lot',
              value: commodity.minOrder
            }, {
              label: 'Priced',
              value: commodity.unit
            }, {
              label: 'Capacity / month',
              value: commodity.monthlyCapacity
            }, {
              label: 'Incoterms',
              value: commodity.incoterms
            }].map(item => <div key={item.label} data-id="element-286" data-mp="25nwkh362656d">
                      <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted" data-id="element-287" data-mp="25oofabrtzyvl">
                        {item.label}
                      </p>
                      <p className="mt-1.5 text-sm text-bone" data-id="element-288" data-mp="3h1qtx1adeed4">{item.value}</p>
                    </div>)}
                </div>
              </div>

              <div data-id="element-289" data-mp="15gzvk9b5261j">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gold" data-id="element-290" data-mp="10fk6m65ubfdv">
                  {commodity.grade}
                </p>
                <h2 className="mt-4 font-display text-4xl leading-tight text-bone" data-id="element-291" data-mp="vnsmadda25w6">
                  {commodity.name}
                </h2>
                <p className="mt-5 text-[15px] leading-relaxed text-muted" data-id="element-292" data-mp="lqxsg7ry8to8">{commodity.description}</p>

                <dl className="mt-8 divide-y divide-hair border-y border-hair" data-id="element-293" data-mp="hpubfhy60rlf">
                  {[{
              label: 'Origin',
              value: commodity.origin
            }, {
              label: 'Form',
              value: commodity.form
            }, {
              label: 'Packaging',
              value: commodity.packaging
            }, ...commodity.specs].map(spec => <div key={spec.label} className="grid grid-cols-[130px_1fr] gap-4 py-3.5" data-id="element-294" data-mp="27268ldsduda3">
                      <dt className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted" data-id="element-295" data-mp="223mn1ehpb3i9">
                        {spec.label}
                      </dt>
                      <dd className="text-sm text-bone/90" data-id="element-296" data-mp="13sbprqzjilwd">{spec.value}</dd>
                    </div>)}
                </dl>

                <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-297" data-mp="usybml0h195b">
                  <a href={quickOrderMailto(commodity.name)} className="inline-flex items-center justify-center gap-2 rounded-sm bg-gold px-6 py-3.5 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-gold-light" data-id="element-298" data-mp="ur3qb5laff0p">
                    <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="74x9puxssqyv" />
                    Place an Order
                  </a>
                  <a href={whatsappLink(`Hello ${company.shortName}, I am interested in ${commodity.name}. Please send your current offer.`)} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-sm border border-[#25D366] px-6 py-3.5 text-sm font-semibold text-[#25D366] transition-colors duration-150 hover:bg-[#25D366] hover:text-[#0a2f16]" data-id="element-300" data-mp="c02rchk63jh5">
                    <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-301" data-mp="3jmovepc56cml" />
                    WhatsApp enquiry
                  </a>
                </div>
              </div>
            </div>)}
      </section>
    </>;
}